import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class WebUserSessionDto
*  Сессия пользователя витрины
*/
export class WebUserSessionDto extends ActiveModel {

  /**
  * id
  * ИД записи в БД<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * created
  * Отметка времени создания<br>
  */
  @ActiveField('')
  created: string = ''


/**
  * updated
  * Отметка времени обновления<br>
  */
  @ActiveField('')
  updated: string = ''


/**
  * expireAt
  * Время завершения действия сессии<br>
  */
  @ActiveField(null)
  expireAt: null | string = null


  /**
  * isLongSession
  * Если true, то сессия является "долгоживущей", иначе создаётся на короткий промежуток времени<br>  */
  @ActiveField(false)
  isLongSession: boolean = false
}
